import icon_home from "../assets/images/icons/icon_home_16px.svg"
import icon_arrow_right from "../assets/images/icons/bread_crumbs_right_arrow.svg"
import { StyledLinkWhite } from "./StyledComponents"
import { useTranslation } from "react-i18next"

export const DoubleCustomBreadCrumbs = (props) => {
    const {t} = useTranslation()

    return (
        <div className="bread-crumbs">
            <div className="bread-crumbs_list">
                <StyledLinkWhite className="bread-crumbs_list__items" href="/">
                    <img src={icon_home} alt="" className="mr-8"/>
                    <p>{t('navbar.home')}</p>
                </StyledLinkWhite>
                <div className="bread-crumbs_list__items">
                    <img src={icon_arrow_right} alt="" className="mr-8" />
                    <p className="text-primary-cyan font-weight-semi-bold">{props.currentPage}</p>
                </div>
            </div>
        </div>
    )
}

export const TripleCustomBreadCrumbs = (props) => {
    const {t} = useTranslation()

    return (
        <div className="bread-crumbs">
            <div className="bread-crumbs_list">
                <StyledLinkWhite className="bread-crumbs_list__items" href="/">
                    <img src={icon_home} alt="" className="mr-8"/>
                    <p>{t('bread-crumbs.home')}</p>
                </StyledLinkWhite>
                <StyledLinkWhite className="bread-crumbs_list__items" href={props.linkToPrevPage}>
                    <img src={icon_arrow_right} alt="" className="mr-8"/>
                    <p>{props.prevPage}</p>
                </StyledLinkWhite>
                <div className="bread-crumbs_list__items">
                    <img src={icon_arrow_right} alt="" className="mr-8" />
                    <p className="text-primary-cyan font-weight-semi-bold">{props.currentPage}</p>
                </div>
            </div>
        </div>
    )
}